module.exports = __webpack_public_path__ + "static/img/11.4187d85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/11.png
// module id = B24s
// module chunks = 0